<template>
    <div class="content" v-cloak v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="正在加载中，请稍后！">
        <div class="content_box overlength_content public_box">
            <div class="search_box">
                <el-form :inline="true" :model="navForm" class="demo-form-inline">
                    <el-form-item label="车牌号/车架号/设备编号:">
                        <el-input class="width_150" v-model="navForm.keyWord" size="small" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="产品类型:" prop="deviceType" v-if="productTypeData && productTypeData.length > 1">
                        <el-select v-model="navForm.deviceType" placeholder="请选择" size="small" class="width_150">
                            <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.dictName" :value="item.metaData"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="运营公司:" prop="subTenantId">
                        <el-cascader popper-class="cascaderStyle" ref="companyRef" v-model="navForm.cascaderVal" :options="cascCaderOptions" :props="cascCaderProps" placeholder="请选择" :show-all-levels="false" @change="handleSelectCost" filterable clearable size="small"></el-cascader>
                    </el-form-item>
                    <el-form-item label="驾驶时间:">
                        <el-date-picker
                            class="forceWidth_250"
                            v-model="value2"
                            @change="pickerChange"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            size="small"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="searchTable" size="small" style="margin-left: 0.2rem">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <el-tabs v-model="activeTab" @tab-click="handleTabChange">
                <el-tab-pane label="驾驶分析" name="driving">
                    <div class="statistics" v-if="drivingHasData">
                        <ul class="device_totle" @click="handleLookDetail('7')">
                            <li @click.stop="linkDetail">
                                <div class="totle_item">
                                    <p>驾驶车辆数</p>
                                    <div class="active">
                                        <b>{{ overviewData && overviewData.hasTripVehicleNum != null ? overviewData.hasTripVehicleNum : '--' }}</b>
                                        <span> 辆</span>
                                    </div>
                                    <div class="special">
                                        <div>
                                            运行率 <b>{{ overviewData && overviewData.travelRate != null ? overviewData.travelRate : '--' }}</b>
                                            <span> %</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="totle_icon">
                                    <img src="../../../public/images/msi/data/data_icon1.png" />
                                </div>
                            </li>
                            <li class="clickLiItem" @click.stop="handleLookDetail('1')">
                                <div class="totle_item">
                                    <p>日均驾驶里程</p>
                                    <div class="active">
                                        <b>{{ overviewData && overviewData.dayAvgMileage != null ? overviewData.dayAvgMileage : '--' }}</b>
                                        <span> km</span>
                                    </div>
                                    <div class="special">
                                        <div>
                                            总驾驶里程 <b>{{ overviewData && overviewData.totalMileage != null ? overviewData.totalMileage : '--' }}</b>
                                            <span> km</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="totle_icon">
                                    <img src="../../../public/images/msi/data/data_icon2.png" />
                                </div>
                            </li>
                            <li class="clickLiItem" @click.stop="handleLookDetail('3')">
                                <div class="totle_item">
                                    <p>日均驾驶时长</p>
                                    <div class="active">
                                        <b>{{ overviewData && overviewData.dayAvgDuration != null ? overviewData.dayAvgDuration : '--' }}</b>
                                        <span> h</span>
                                    </div>
                                    <div class="special">
                                        <div>
                                            总驾驶时长 <b>{{ overviewData && overviewData.totalDuration != null ? overviewData.totalDuration : '--' }}</b>
                                            <span> h</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="totle_icon">
                                    <img src="../../../public/images/msi/data/data_icon3.png" />
                                </div>
                            </li>
                            <li class="special_item clickLiItem" @click.stop="handleLookDetail('5')">
                                <div class="totle_item">
                                    <p>日均驾驶数</p>
                                    <div class="active">
                                        <b>{{ overviewData && overviewData.dayAvgTripNum != null ? overviewData.dayAvgTripNum : '--' }}</b>
                                        <span> 条</span>
                                    </div>
                                    <div class="special">
                                        <div>
                                            总行程数量 <b>{{ overviewData && overviewData.totalTripNum != null ? overviewData.totalTripNum : '--' }}</b>
                                            <span> 条</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="totle_icon">
                                    <img src="../../../public/images/msi/data/data_icon4.png" />
                                </div>
                            </li>
                        </ul>
                        <ul class="device_totle">
                            <li class="clickLiItem" @click="handleLookDetail('11')">
                                <div class="totle_item">
                                    <p>车队日均驾驶时长</p>
                                    <div class="active">
                                        <b>{{ fleetAvgDurationData && fleetAvgDurationData.avgVal != null ? fleetAvgDurationData.avgVal : '--' }}</b>
                                        <span> h</span>
                                    </div>
                                </div>
                                <div class="totle_icon">
                                    <img src="../../../public/images/msi/data/data_icon5.png" />
                                </div>
                            </li>
                            <li class="clickLiItem" @click="handleLookDetail('8')">
                                <div class="totle_item">
                                    <p>车辆最高速度</p>
                                    <div class="active">
                                        <b>{{ overviewData && overviewData.maxVehicleSpeed != null ? overviewData.maxVehicleSpeed : 0 }}</b>
                                        <span> km/h</span>
                                    </div>
                                    <div class="special">
                                        <div>
                                            车辆平均速度 <b>{{ overviewData && overviewData.avgVehicleSpeed != null ? overviewData.avgVehicleSpeed : '--' }}</b>
                                            <span> km/h</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="totle_icon">
                                    <img src="../../../public/images/msi/data/data_icon6.png" />
                                </div>
                            </li>
                            <li>
                                <div class="totle_item">
                                    <p>平均驾驶评分</p>
                                    <div class="active">
                                        <b>{{ overviewData && overviewData.avgDrivingScore != null ? overviewData.avgDrivingScore : '--' }}</b>
                                        <span> 分</span>
                                    </div>
                                    <div class="special">
                                        <div>
                                            低于平均评分车辆 <b>{{ overviewData && overviewData.lowerAvgDrivingScoreVehicleNum != null ? overviewData.lowerAvgDrivingScoreVehicleNum : 0 }}</b>
                                            <span> 辆</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="totle_icon">
                                    <img src="../../../public/images/msi/data/data_icon7.png" />
                                </div>
                            </li>
                            <li class="special_item clickLiItem" @click="handleLookDetail('10')">
                                <div class="totle_item">
                                    <p>百公里三急一超次数</p>
                                    <div class="active">
                                        <span>单车最高 </span>
                                        <b>{{ overviewData && overviewData.maxThreeUrgentOneOvertaking != null ? overviewData.maxThreeUrgentOneOvertaking : '--' }}</b>
                                        <span> 次</span>
                                    </div>
                                    <div class="special">
                                        <div>
                                            平均 <b>{{ overviewData && overviewData.avgThreeUrgentOneOvertaking != null ? Number(overviewData.avgThreeUrgentOneOvertaking).toFixed(2) : '--' }}</b>
                                            <span> 次</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="totle_icon">
                                    <img src="../../../public/images/msi/data/data_icon8.png" />
                                </div>
                            </li>
                        </ul>
                        <ul class="charts_box" v-loading="queryDataLoading" :class="{ two_li: queryCompanyId }">
                            <li>
                                <div class="detail_title">驾驶评分分布图</div>
                                <div id="vehicle_line_charts"></div>
                            </li>
                            <li class="active">
                                <div class="detail_title">驾驶时段分布图</div>
                                <div id="vehicle_pie_charts"></div>
                            </li>
                            <li class="active">
                                <div class="detail_title">三急一超Top3</div>
                                <div id="chart_line"></div>
                            </li>
                        </ul>
                    </div>
                    <div v-else class="empty_box">
                        <el-empty description="暂无数据"></el-empty>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="设备异常分析" name="device-abnormal">
                    <div class="statistics" v-if="deviceAbnormalHasData">
                        <ul class="device_totle abnormal_cards">
                            <li class="clickLiItem" @click="openDeviceAbnormalDetail('online')">
                                <div class="totle_item">
                                    <p>设备在线统计</p>
                                    <div class="active">
                                        <b>{{ deviceAbnormalOverviewData && deviceAbnormalOverviewData.onlineVehicleNum != null ? deviceAbnormalOverviewData.onlineVehicleNum : '--' }}</b>
                                        <span> 辆</span>
                                    </div>
                                    <div class="special">
                                        <div>
                                            占比 <b>{{ deviceAbnormalOverviewData && deviceAbnormalOverviewData.onlineRate != null ? deviceAbnormalOverviewData.onlineRate : '--' }}</b>
                                            <span> %</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="totle_icon">
                                    <img src="../../../public/images/msi/data/data_icon1.png" />
                                </div>
                            </li>
                            <li class="clickLiItem" @click="openDeviceAbnormalDetail('offline')">
                                <div class="totle_item">
                                    <p>设备离线统计</p>
                                    <div class="active">
                                        <b>{{ deviceAbnormalOverviewData && deviceAbnormalOverviewData.offlineVehicleNum != null ? deviceAbnormalOverviewData.offlineVehicleNum : '--' }}</b>
                                        <span> 辆</span>
                                    </div>
                                    <div class="special">
                                        <div>
                                            占比 <b>{{ deviceAbnormalOverviewData && deviceAbnormalOverviewData.offlineRate != null ? deviceAbnormalOverviewData.offlineRate : '--' }}</b>
                                            <span> %</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="totle_icon">
                                    <img src="../../../public/images/msi/data/data_icon5.png" />
                                </div>
                            </li>
                            <li v-if="showPulledOutCard" class="clickLiItem" @click="openDeviceAbnormalDetail('pulledOut')">
                                <div class="totle_item">
                                    <p>拔出统计</p>
                                    <div class="active">
                                        <b>{{ deviceAbnormalOverviewData && deviceAbnormalOverviewData.pulledOutVehicleNum != null ? deviceAbnormalOverviewData.pulledOutVehicleNum : '--' }}</b>
                                        <span> 辆</span>
                                    </div>
                                    <div class="special">
                                        <div>
                                            占比 <b>{{ deviceAbnormalOverviewData && deviceAbnormalOverviewData.pulledOutRate != null ? deviceAbnormalOverviewData.pulledOutRate : '--' }}</b>
                                            <span> %</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="totle_icon">
                                    <img src="../../../public/images/msi/data/data_icon6.png" />
                                </div>
                            </li>
                            <li class="clickLiItem" @click="openDeviceAbnormalDetail('noTrip7d')">
                                <div class="totle_item">
                                    <p>7天无行程统计</p>
                                    <div class="active">
                                        <b>{{ deviceAbnormalOverviewData && deviceAbnormalOverviewData.noTrip7dVehicleNum != null ? deviceAbnormalOverviewData.noTrip7dVehicleNum : '--' }}</b>
                                        <span> 辆</span>
                                    </div>
                                    <div class="special">
                                        <div>
                                            占比 <b>{{ deviceAbnormalOverviewData && deviceAbnormalOverviewData.noTrip7dRate != null ? deviceAbnormalOverviewData.noTrip7dRate : '--' }}</b>
                                            <span> %</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="totle_icon">
                                    <img src="../../../public/images/msi/data/data_icon7.png" />
                                </div>
                            </li>
                            <li class="clickLiItem" @click="openFatigueDrivingDetail">
                                <div class="totle_item">
                                    <p>疲劳驾驶车辆</p>
                                    <div class="active">
                                        <b>{{ fatigueDrivingOverviewData.fatigueDrivingVehicleNum != null ? fatigueDrivingOverviewData.fatigueDrivingVehicleNum : '--' }}</b>
                                        <span> 辆</span>
                                    </div>
                                    <div class="special">
                                        占比 <b>{{ fatigueDrivingOverviewData.fatigueDrivingVehicleRate != null ? fatigueDrivingOverviewData.fatigueDrivingVehicleRate : '--' }}</b><span> %</span>
                                    </div>
                                </div>
                                <div class="totle_icon"><img src="../../../public/images/msi/data/data_icon5.png" /></div>
                            </li>
                        </ul>
                    </div>
                    <div v-else class="empty_box" v-loading="deviceAbnormalLoading">
                        <el-empty description="暂无数据"></el-empty>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>

        <behavioural-detail v-if="dialogVisible" :dialogVisible="dialogVisible" :startTime="navForm.startTime" :endTime="navForm.endTime" :platNo="lookDetailPlatNo" @beforeClose="dialogVisible = false"></behavioural-detail>
        <el-dialog :visible.sync="dialogDetailVisible" :width="currentWidth < 1000 && currentWidth > 0 ? '95%' : '1300px'" :title="detailTitleObj[detailQueryForm.label]" :modal-append-to-body="false">
            <vehicle-detail v-if="dialogDetailVisible" :detailQueryForm="detailQueryForm"></vehicle-detail>
        </el-dialog>
        <el-dialog :visible.sync="deviceAbnormalDetailVisible" :width="currentWidth < 1000 && currentWidth > 0 ? '95%' : '1300px'" :title="deviceAbnormalDetailTitleMap[deviceAbnormalDetailType]" :modal-append-to-body="false">
            <vehicle-device-abnormal-detail v-if="deviceAbnormalDetailVisible" :detailQueryForm="deviceAbnormalDetailQueryForm" :detailType="deviceAbnormalDetailType"></vehicle-device-abnormal-detail>
        </el-dialog>
        <el-dialog :visible.sync="fatigueDrivingDetailVisible" title="疲劳驾驶车辆明细" :width="currentWidth < 1000 && currentWidth > 0 ? '95%' : '1100px'" :modal-append-to-body="false">
            <div class="table_toolbar">
                <el-button type="primary" size="small" icon="el-icon-download" :loading="fatigueDrivingDownloadLoading" :disabled="!fatigueDrivingDetailTotal" @click="downloadFatigueDrivingDetail">下载</el-button>
            </div>
            <el-table :data="fatigueDrivingDetailData" border v-loading="fatigueDrivingDetailLoading">
                <el-table-column type="index" label="序号" width="60" />
                <el-table-column prop="plateNo" label="车牌号" />
                <el-table-column prop="vin" label="车架号" />
                <el-table-column prop="fleetName" label="车队" />
                <el-table-column prop="fatigueDrivingDuration" label="当日疲劳驾驶时长（小时）" />
                <el-table-column prop="fatigueDrivingCount" label="当日疲劳驾驶次数" />
            </el-table>
            <el-pagination class="fatigue-pagination" @current-change="loadFatigueDrivingDetail" :current-page="fatigueDrivingDetailPage" :page-size="10" layout="total, prev, pager, next" :total="fatigueDrivingDetailTotal" />
        </el-dialog>
    </div>
</template>

<script>
import { EventBus } from '../../assets/js/EventBus.js';
import * as echarts from 'echarts';
import * as XLSX from 'xlsx';
import BehaviouralDetail from '@/components/BehaviouralDetail.vue';
import VehicleDetail from '@/components/VehicleDetail.vue';
import VehicleDeviceAbnormalDetail from '@/components/VehicleDeviceAbnormalDetail.vue';

let _this;
export default {
    name: 'VehicleData',
    props: {
        msg: String
    },
    components: {
        BehaviouralDetail,
        VehicleDetail,
        VehicleDeviceAbnormalDetail
    },
    data() {
        return {
            activeTab: 'driving',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ],
                disabledDate(time) {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return time.getTime() >= today.getTime();
                }
            },
            value2: '',
            chartLine: '',
            chartPie: '',
            chartBar: '',
            chartLeft0: '',
            dialogVisible: false,
            dialogDetailVisible: false,
            deviceAbnormalDetailVisible: false,
            fatigueDrivingDetailVisible: false,
            fatigueDrivingDetailLoading: false,
            fatigueDrivingDetailData: [],
            fatigueDrivingDetailPage: 1,
            fatigueDrivingDetailTotal: 0,
            fatigueDrivingDownloadLoading: false,
            fatigueDrivingOverviewData: {},
            deviceAbnormalDetailType: 'offline',
            deviceAbnormalDetailTitleMap: {
                offline: '设备离线明细',
                online: '设备在线明细',
                pulledOut: '设备拔出明细',
                noTrip7d: '7天无行程明细'
            },
            deviceAbnormalDetailQueryForm: {},
            lookTrackDeviceNumber: '',
            detailTitleObj: {
                1: '车辆驾驶里程分布',
                3: '车辆驾驶时长分布',
                5: '车辆行程数量分布',
                7: '车辆运行率分布',
                8: '车辆速度分布',
                10: '车辆百公里三急一超分布',
                11: '车队日均驾驶时长'
            },
            lookDetailPlatNo: '',
            queryCompanyId: false,
            isSingleCity: false,
            rid: '',
            loading: false,
            fullscreenLoading: false,
            detailPageVisible: false,
            formType: '',
            singleCityData: [],
            vehicleStatisticsData: true,
            lastMonthDrivingTimeDistribution: '',
            lastMonthScoreDistribution: '',
            lastMonthScoreTopCity: '',
            batchIdList: [],
            detailQueryForm: { label: 1 },
            navForm: {
                cascaderVal: null,
                tripTimeMin: '',
                tripTimeMax: '',
                companyId: null,
                keyWord: null,
                startTime: null,
                endTime: null,
                fleetId: null,
                deviceType: null
            },
            modeForm: {
                name: ''
            },
            overviewData: {},
            deviceAbnormalOverviewData: {},
            companyList: [],
            queryDataLoading: false,
            deviceAbnormalLoading: false,
            currentUser: {},
            cascCaderProps: {
                children: 'subTenantTreeLists',
                label: 'tenantName',
                value: 'tenantId',
                expandTrigger: 'hover',
                checkStrictly: true
            },
            fleetAvgDurationData: null,
            currentWidth: 0
        };
    },
    computed: {
        productTypeData() {
            let typeData = this.$store.state.common.productTypeData;
            if (typeData && typeData.length) {
                let expandItem = typeData.find((item) => item.expandInfo);
                if (this.navForm.deviceType == null) {
                    this.navForm.deviceType = expandItem ? expandItem.metaData : typeData[0].metaData;
                }
            }
            return typeData;
        },
        cascCaderOptions() {
            return this.$store.state.common.companyTreeData;
        },
        drivingHasData() {
            return this.overviewData && Object.keys(this.overviewData).length > 0;
        },
        deviceAbnormalHasData() {
            return this.deviceAbnormalOverviewData && Object.prototype.hasOwnProperty.call(this.deviceAbnormalOverviewData, 'totalVehicleNum');
        },
        showPulledOutCard() {
            return String(this.navForm.deviceType) === '0';
        }
    },
    mounted() {
        _this = this;
        this.currentWidth = window.innerWidth;
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.navForm.companyId = this.userInfo.company;
        this.setLastWeek();
        this.getDrivingTabData();
        this.getCurrentUser();
        this.handleQuery();

        window.addEventListener('resize', () => {
            setTimeout(() => {
                this.chartLine && this.chartLine.resize();
                this.chartPie && this.chartPie.resize();
                this.chartBar && this.chartBar.resize();
                this.chartLeft0 && this.chartLeft0.resize();
            }, 500);
        });
    },
    destroyed() {
        this.chartLine && this.chartLine.dispose();
        this.chartPie && this.chartPie.dispose();
        this.chartBar && this.chartBar.dispose();
        this.chartLeft0 && this.chartLeft0.dispose();
    },
    methods: {
        getDrivingTabData() {
            this.getData();
            this.getFleetAvgDuration();
        },
        getFleetAvgDuration() {
            let joggleData = {
                condition: this.buildRequestForm(),
                pageNo: 1,
                pageSize: 10
            };
            this.$request({ method: 'post', url: '/report/api/vehicleDashboard/fetchVehicleByTenantIndex/avgDuration', data: joggleData }).then((res) => {
                if (res.code == 200) {
                    this.fleetAvgDurationData = res.data;
                }
            });
        },
        handleQuery() {
            if (this.$route.query && this.$route.query.tab === 'device-abnormal') {
                this.activeTab = 'device-abnormal';
                this.getDeviceAbnormalOverview();
            }
            if (this.$route.query && this.$route.query.handleLookDetail) {
                this.handleLookDetail(this.$route.query.hrefTypeStr);
            }
        },
        handleTabChange() {
            if (this.activeTab === 'device-abnormal' && !this.deviceAbnormalHasData && !this.deviceAbnormalLoading) {
                this.getDeviceAbnormalOverview();
            }
        },
        setLastWeek() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);

            function formatDate(date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            }
            this.value2 = [formatDate(start), formatDate(end)];
            this.pickerChange(this.value2);
        },
        pickerChange(val) {
            if (val && val.length > 1) {
                this.navForm.startTime = val[0] + ' 00:00:00';
                this.navForm.tripTimeMin = val[0] + ' 00:00:00';
                this.navForm.endTime = val[1] + ' 23:59:59';
                this.navForm.tripTimeMax = val[1] + ' 23:59:59';
            } else {
                this.navForm.startTime = null;
                this.navForm.tripTimeMin = null;
                this.navForm.endTime = null;
                this.navForm.tripTimeMax = null;
            }
        },
        handleSelectCost(val) {
            this.navForm.companyId = val && val.length > 0 ? val[val.length - 1] : null;
            this.$refs.companyRef.dropDownVisible = false;
        },
        getCurrentUser() {
            this.$request({ method: 'get', url: '/ubi/api/tenant/currentUser', params: {} }).then((res) => {
                if (res.code == 200) {
                    this.currentUser = res.data;
                }
            });
        },
        linkDetail() {
            sessionStorage.setItem('vehicleNavForm', JSON.stringify(this.navForm));
            EventBus.$emit('drivingBehavior', '');
        },
        beforeClose() {
            this.$emit('update:messageParent', false);
            this.dialogDetailVisible = false;
        },
        handleLookDetail(val) {
            var navForm = JSON.parse(JSON.stringify(this.navForm));
            navForm.label = val;
            this.detailQueryForm = navForm;
            this.dialogDetailVisible = true;
            this.$emit('update:messageParent', true);
        },
        openDeviceAbnormalDetail(type) {
            this.deviceAbnormalDetailType = type;
            this.deviceAbnormalDetailQueryForm = JSON.parse(JSON.stringify(this.buildRequestForm()));
            this.deviceAbnormalDetailVisible = true;
        },
        buildRequestForm() {
            let form = JSON.parse(JSON.stringify(this.navForm));
            if (form.deviceType == 2) {
                form.deviceType = 1;
                form.shortTermRental = true;
            } else if (form.deviceType == 1) {
                form.shortTermRental = false;
            }
            return form;
        },
        getData() {
            this.queryDataLoading = true;
            this.getDrivingScore();
            this.getDrivingPeriod();
            this.getThreeUrgentOneOvertaking();

            this.$request({ method: 'post', url: '/report/api/vehicleDashboard/overview', data: this.buildRequestForm() }).then((res) => {
                this.queryDataLoading = false;
                if (res.code == 200) {
                    this.overviewData = res.data || {};
                }
            });
        },
        getDeviceAbnormalOverview() {
            this.deviceAbnormalLoading = true;
            this.$request({ method: 'post', url: '/report/api/vehicleDashboard/deviceAbnormalOverview', data: this.buildRequestForm() }).then((res) => {
                this.deviceAbnormalLoading = false;
                if (res.code == 200) {
                    this.deviceAbnormalOverviewData = res.data || {};
                    this.getFatigueDrivingOverview();
                }
            }).catch(() => {
                this.deviceAbnormalLoading = false;
                this.deviceAbnormalOverviewData = {};
            });
        },
        getFatigueDrivingOverview() {
            this.$request({ method: 'post', url: '/report/api/vehicleDashboard/fatigueDrivingOverview', data: this.buildRequestForm() }).then((res) => {
                if (res.code == 200) this.fatigueDrivingOverviewData = res.data || {};
            }).catch(() => { this.fatigueDrivingOverviewData = {}; });
        },
        openFatigueDrivingDetail() {
            this.fatigueDrivingDetailVisible = true;
            this.fatigueDrivingDetailPage = 1;
            this.loadFatigueDrivingDetail(1);
        },
        loadFatigueDrivingDetail(page) {
            this.fatigueDrivingDetailPage = page || 1;
            this.fatigueDrivingDetailLoading = true;
            this.$request({ method: 'post', url: '/report/api/vehicleDashboard/fatigueDrivingDetail', data: { condition: this.buildRequestForm(), pageNo: this.fatigueDrivingDetailPage, pageSize: 10 } }).then((res) => {
                if (res.code == 200) {
                    const data = res.data || {};
                    this.fatigueDrivingDetailData = data.list || [];
                    this.fatigueDrivingDetailTotal = Number(data.total || 0);
                }
            }).finally(() => { this.fatigueDrivingDetailLoading = false; });
        },
        downloadFatigueDrivingDetail() {
            if (!this.fatigueDrivingDetailTotal || this.fatigueDrivingDownloadLoading) return;
            this.fatigueDrivingDownloadLoading = true;
            this.$request({ method: 'post', url: '/report/api/vehicleDashboard/fatigueDrivingDetail', data: { condition: this.buildRequestForm(), pageNo: 1, pageSize: this.fatigueDrivingDetailTotal } }).then((res) => {
                const records = res.code === 200 && res.data ? (res.data.list || []) : [];
                if (!records.length) { this.$message.error('暂无可下载的数据'); return; }
                const rows = records.map((item) => ({ 车牌号: item.plateNo || '--', 车架号: item.vin || '--', 车队: item.fleetName || '--', '当日疲劳驾驶时长（小时）': item.fatigueDrivingDuration == null ? '--' : item.fatigueDrivingDuration, 当日疲劳驾驶次数: item.fatigueDrivingCount == null ? 0 : item.fatigueDrivingCount }));
                const worksheet = XLSX.utils.json_to_sheet(rows);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, '疲劳驾驶明细');
                this.$$exportFile(XLSX.write(workbook, { bookType: 'xlsx', type: 'array' }), '疲劳驾驶车辆明细.xlsx');
            }).catch(() => this.$message.error('下载失败，请稍后重试！')).finally(() => { this.fatigueDrivingDownloadLoading = false; });
        },
        getDrivingScore() {
            this.$request({ method: 'post', url: '/report/api/vehicleDashboard/drivingScoreDistribution', data: this.buildRequestForm() }).then((res) => {
                if (res.code == 200) {
                    let xAxisData = [];
                    let yAxisData = [];
                    let chartsData = res.data || [];
                    chartsData.sort((a, b) => a.drivingScore - b.drivingScore);
                    chartsData.forEach((item) => {
                        xAxisData.push(item.drivingScore);
                        yAxisData.push(item.vehicleNum);
                    });
                    this.loadLineCharts(xAxisData, yAxisData);
                }
            });
        },
        getDrivingPeriod() {
            this.$request({ method: 'post', url: '/report/api/vehicleDashboard/drivingPeriodDistribution', data: this.buildRequestForm() }).then((res) => {
                if (res.code == 200) {
                    let chartsData = res.data;
                    if (!chartsData) {
                        return;
                    }
                    this.loadPieCharts(chartsData);
                }
            });
        },
        getThreeUrgentOneOvertaking() {
            this.$request({ method: 'post', url: '/report/api/vehicleDashboard/threeUrgentOneOvertaking', data: this.buildRequestForm() }).then((res) => {
                if (res.code == 200) {
                    const indicatorMap = [
                        { field: 'rapidAccelerationPer100kmCount', name: '急加速' },
                        { field: 'rapidDecelerationPer100kmCount', name: '急减速' },
                        { field: 'rapidTurnPer100kmCount', name: '急转弯' },
                        { field: 'overspeedPer100kmCount', name: '超速' }
                    ];

                    let chartData = res.data || [];
                    if (chartData.length < 1) {
                        return;
                    }

                    let xAxisData = chartData.map((chart) => chart.tenantName);
                    let seriesData = indicatorMap.map((indicator) => ({
                        name: indicator.name,
                        color: '',
                        data: chartData.map((chart) => chart[indicator.field])
                    }));
                    this.loadRightLineCharts(xAxisData, seriesData);
                }
            });
        },
        loadRightLineCharts(xAxisData, seriesData) {
            let chartDom = document.getElementById('chart_line');
            if (!chartDom) return;
            this.chartLeft0 = echarts.init(chartDom, null, { renderer: 'svg' });
            let colors = ['#488CF7', '#38CAFB', '#91CC75', '#FAC858'];
            let option = {
                color: colors,
                textStyle: { fontFamily: 'PingFang Regular' },
                tooltip: { trigger: 'axis', confine: true },
                legend: {
                    data: seriesData.map((s) => s.name),
                    textStyle: { color: '#fff', fontSize: 12 },
                    top: -5,
                    left: 'center',
                    orient: 'horizontal',
                    itemWidth: 8,
                    itemHeight: 8,
                    itemGap: 15
                },
                grid: { top: '12%', left: '13%', right: '6%', bottom: '40px' },
                xAxis: {
                    data: xAxisData,
                    axisLabel: {
                        rotate: 20,
                        interval: 0,
                        formatter: function (value) {
                            const maxLength = 6;
                            return value.length > maxLength ? value.substring(0, maxLength) + '...' : value;
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params) {
                                return params.value;
                            }
                        }
                    }
                },
                yAxis: {
                    name: '次',
                    nameTextStyle: { color: '#fff' },
                    splitLine: {
                        show: true,
                        lineStyle: { color: '#2C4A7B', width: 1, type: 'solid' }
                    }
                },
                series: seriesData.map((s) => ({
                    type: 'bar',
                    barMaxWidth: 7,
                    barGap: '90%',
                    itemStyle: { borderRadius: [20, 20, 0, 0] },
                    ...s
                }))
            };
            this.chartLeft0.setOption(option);
        },
        loadPieCharts(chartsData) {
            var chartDom = document.getElementById('vehicle_pie_charts');
            if (!chartDom) return;
            this.chartPie = echarts.init(chartDom, null, { renderer: 'svg' });
            let seriesData = [];
            let tips = ['7-9时', '9-12时', '12-17时', '17-19时', '19-24时', '0-4时', '4-7时'];
            let fieldMapping = {
                '0-4时': 'drivingDuration04',
                '4-7时': 'drivingDuration47',
                '7-9时': 'drivingDuration79',
                '9-12时': 'drivingDuration912',
                '12-17时': 'drivingDuration1217',
                '17-19时': 'drivingDuration1719',
                '19-24时': 'drivingDuration1924'
            };

            tips.forEach((item) => {
                seriesData.push({ name: item, value: chartsData[fieldMapping[item]] });
            });

            var option = {
                color: ['#488CF7', '#38CAFB', '#4CAFF9', '#4ADFCB', '#2AAEFA', '#0271F4', '#1D3F7F'],
                tooltip: { formatter: '{b0} : {c0}小时 ', show: true },
                series: [
                    {
                        type: 'pie',
                        radius: ['25%', '50%'],
                        center: ['50%', '55%'],
                        label: {
                            color: '#000000',
                            formatter(target) {
                                return target.name + '\n' + target.percent.toFixed(1) + '%';
                            }
                        },
                        data: seriesData
                    }
                ]
            };
            this.chartPie.setOption(option);
        },
        loadLineCharts(xAxisData, yAxisData) {
            var chartDom = document.getElementById('vehicle_line_charts');
            if (!chartDom) return;
            this.chartLine = echarts.init(chartDom, null, { renderer: 'svg' });
            var option = {
                xAxis: {
                    type: 'category',
                    name: '(分)',
                    nameTextStyle: { color: '#666666' },
                    boundaryGap: false,
                    axisLabel: {
                        interval: 2,
                        textStyle: { color: '#666666' }
                    },
                    splitLine: { show: false },
                    axisTick: { show: false },
                    axisLine: { show: true, lineStyle: { width: '2', color: '#E7E7EE' } },
                    data: xAxisData
                },
                yAxis: {
                    type: 'value',
                    axisLabel: { textStyle: { color: '#666666' } },
                    name: this.navForm.keyWord ? '(次)' : '(辆)',
                    nameTextStyle: { color: '#666666' },
                    axisLine: { show: true, lineStyle: { width: '2', color: '#E7E7EE' } },
                    splitLine: { show: true, lineStyle: { type: 'dashed' } }
                },
                tooltip: { trigger: 'axis', formatter: '{b0} 分: {c0} ' + (this.navForm.keyWord ? '次' : '辆车') },
                grid: { top: '30', bottom: '40px', left: '12%', right: '40' },
                series: [
                    {
                        data: yAxisData,
                        type: 'line',
                        smooth: true,
                        showSymbol: false,
                        lineStyle: { color: '#05A9C5' }
                    }
                ]
            };
            this.chartLine.setOption(option);
        },
        searchTable() {
            if (this.navForm.startTime && this.navForm.endTime && this.calcMonthInterval(this.navForm.startTime, this.navForm.endTime) > 12) {
                this.$message.error('抱歉，仅支持查询12个月及以内的数据！');
                return false;
            }
            if (this.activeTab === 'device-abnormal') {
                this.getDeviceAbnormalOverview();
            } else {
                this.getDrivingTabData();
            }
        }
    }
};
</script>

<style lang="less" scoped>
.content {
    position: relative;

    .content_box {
        height: calc(100vh - 60px);
        background: #ffffff;
        box-shadow: 0px 2px 4px 0px rgba(223, 223, 223, 0.5);
        border-radius: 6px;
        border: 1px solid #ececec;
        padding: 0.2rem;
        li {
            position: relative;
            .nullChartData {
                margin-top: 100px;
                text-align: center;
                font-size: 17px;
            }
        }
    }

    .detail_title {
        margin: 0;
        padding-left: 0.2rem;
    }
    .charts_box {
        width: 100%;
        display: flex;
    }
    .charts_box > li {
        width: 33.33%;
        height: calc(100vh - 6.8rem);
        padding-top: 0.2rem;
    }
    .charts_box > li:last-child {
        padding-left: 0.1rem;
    }
    .charts_box.two_li > li {
        width: 48%;
        padding: 0.2rem 1rem;
    }
    .charts_box.two_li > .active {
        border-right: none;
    }
    .charts_box > .active {
        border-left: 1px solid #e0e0e0;
        border-right: 1px solid #e0e0e0;
    }
    .charts_box > .active:nth-child(3) {
        border: 0 !important;
    }
    .device_totle {
        margin-bottom: 0.25rem;
        width: 100%;
        display: flex;
        justify-content: space-between;
        li {
            width: 23.8%;
            min-height: 1.7rem;
            background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0.19) 34%, rgba(77, 194, 214, 0.08) 100%);
            box-shadow: 0px 2px 14px 0px rgba(222, 222, 222, 0.5);
            border-radius: 6px;
            padding: 0.14rem 0.2rem;
            display: flex;
            justify-content: space-between;
            font-size: 0.22rem;
            font-weight: 400;
            color: #000000;
            cursor: pointer;
        }
        .clickLiItem:hover {
            border: 1px solid #38cafb;
        }
    }
    .abnormal_cards li {
        width: 18.8%;
    }
    .totle_item {
        b {
            font-size: 0.32rem;
            font-weight: 600;
        }
        span {
            color: rgba(130, 136, 147, 1);
        }
        .active {
            margin-top: 0.2rem;
        }
    }
    .totle_icon {
        width: 0.64rem;
        margin-top: 0.54rem;
    }
    .special {
        display: flex;
        font-size: 0.18rem;
        margin-top: 0.14rem;
        color: #828893;
        b {
            color: rgba(5, 169, 197, 1);
            font-size: 0.24rem;
        }
        span {
            color: rgba(5, 169, 197, 1);
        }
    }

    #vehicle_line_charts,
    #vehicle_pie_charts,
    #vehicle_bar_charts,
    #chart_line {
        width: 100%;
        height: calc(100% - 30px);
        margin-top: 0.2rem;
        div {
            height: 100%;
        }
    }
}
.statistics {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    margin-bottom: 20px;
    .device_totle {
        margin-bottom: 0;
    }
}
.empty_box {
    margin-top: 0.8rem;
}
.table_toolbar {
    height: 32px;
    margin-bottom: 8px;
    text-align: right;
}
.fatigue-pagination {
    margin-top: 0.2rem;
}
@media (max-height: 710px) {
    .content {
        .charts_box {
            li {
                height: calc(100vh - 6.3rem);
            }
        }
    }
}
</style>
